import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b8e870e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-bar" }

import { useRoute } from "vue-router";
// active 状态直接跟随当前路由，刷新 / footer 跳转 / 前进后退都能正确高亮

export default /*#__PURE__*/_defineComponent({
  __name: 'TabBar',
  setup(__props) {

const route = useRoute();
const tabs = [
  {
    link: "/",
    label: "首页",
  },
  {
    link: "/product",
    label: "产品介绍",
  },
  {
    link: "/platform",
    label: "数字化平台",
  },
  {
    link: "/customization",
    label: "定制化服务",
  },
  {
    link: "/contact",
    label: "联系我们",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
      return _createVNode(_component_router_link, {
        to: tab.link,
        key: tab.link,
        class: _normalizeClass(['tab-link', { active: _unref(route).path === tab.link }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(tab.label), 1)
        ]),
        _: 2
      }, 1032, ["to", "class"])
    }), 64))
  ]))
}
}

})